// Tipos do chat de suporte (espelham a API privada do chatwoot, repassada pelo gestorSuporte).

// `triage` e `resolved` (resolvido na própria triagem) não entram na fila do
// atendente; só aparecem no histórico do entregador.
export type TicketStatus = "triage" | "waiting_agent" | "open" | "closed" | "resolved";

// O que a fila mostra: só o que saiu da triagem encaminhado para humano.
export type FilaStatus = Extract<TicketStatus, "waiting_agent" | "open" | "closed">;

export const isFinal = (s: TicketStatus) => s === "closed" || s === "resolved";

export type SenderType = "contact" | "bot" | "agent" | "system";

export interface Ticket {
  ticket_id: string;
  contact_id: string;
  telefone: string;
  ops: string;
  status: TicketStatus;
  triage_summary?: string;
  assigned_agent?: string;
  assigned_agent_id?: string;
  created_by: string;
  created_at: string;
  updated_at: string;
  closed_at?: string;
  closed_by?: string;
  last_message_at?: string;
  last_message_preview?: string;
  last_contact_message_at?: string;
  last_agent_message_at?: string;
}

// Mensagem do entregador mais nova que a última resposta do atendente.
export const aguardandoResposta = (t: Ticket): boolean =>
  !!t.last_contact_message_at && (!t.last_agent_message_at || t.last_contact_message_at > t.last_agent_message_at);

export interface Message {
  msg_id: string;
  ticket_id: string;
  sender_type: SenderType;
  sender_name: string | null;
  body: string;
  created_at: string;
  pendente?: boolean; // resposta do atendente ainda não confirmada (otimista)
}

export interface Page<T> {
  items: T[];
  next_cursor: string | null;
}

export interface TicketMessages {
  status: TicketStatus;
  items: Message[];
}

export interface MagicLink {
  url: string;
  expires_at: string;
  contact_id: string;
  ticket_id: string;
  status: TicketStatus;
  reused: boolean;
}

export const STATUS_LABEL: Record<TicketStatus, string> = {
  waiting_agent: "Aguardando",
  open: "Em atendimento",
  triage: "Em triagem",
  closed: "Encerrado",
  resolved: "Resolvido na triagem",
};

// Aviso em massa: uma mensagem para todos os entregadores que chegaram por um
// item do menu principal da triagem, seguida do encerramento dos atendimentos.
export interface AvisoMenu {
  id: string;
  label: string;
}

// Quais tickets entram. `open` já tem um atendente conversando.
export type AvisoStatus = "waiting_agent" | "triage" | "open";

export interface AvisoFiltro {
  menu: string;
  since: string; // ISO
  statuses: AvisoStatus[];
}

export interface AvisoPrevia {
  total: number;
  by_status: Partial<Record<AvisoStatus, number>>;
}

// Resultado de um lote; repetir com `next_cursor` até ele vir nulo.
export interface AvisoLote {
  processed: number;
  sent: number;
  closed: number;
  skipped: number; // já estava encerrado quando chegou a vez
  failed: { ticket_id: string; error: string }[];
  next_cursor: string | null;
}

export const AVISO_STATUS_LABEL: Record<AvisoStatus, string> = {
  waiting_agent: "Aguardando atendente",
  triage: "Ainda na triagem",
  open: "Já em atendimento",
};
